var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertifiedPreviewBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0L39 11.25V33.75L19.5 45L0 33.75V11.25L19.5 0Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3.46346L3 12.9827V32.0173L19.5 41.5365L36 32.0173V12.9827L19.5 3.46346ZM39 11.25L19.5 0L0 11.25V33.75L19.5 45L39 33.75V11.25Z",
    fill: "#1D2933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9854 31V15C12.1124 16.1852 11.8307 20.3333 16.9025 20.3333C20.6828 20.3333 21.9743 20.3333 25.3555 22.1111C28.7367 23.8889 27.8914 27.4444 27.8914 27.4444C27.8914 27.4444 27.1166 25.6667 23.7354 25.6667C21.8226 25.6667 15.2119 29.2222 10.9854 31Z",
    fill: "#FF6633"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9854 11.2415L19.5 0L19.4854 0.00844992V44.9916L19.5 45L38.9854 33.7584V11.2415Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifiedPreviewBadge);
export default __webpack_public_path__ + "static/media/certified_preview_badge.f46c6646ae86a2382e2b0519260014b1.svg";
export { ForwardRef as ReactComponent };